// import { getMouse3dDirection } from "@/components/geometry/editObject";

function getMouse3dDirection(event) {
  var direction = null;
  if (event && event.pageX && event.pageY) {
    if (!stl_cont) {
      stl_cont = document.getElementById("stl_cont");
    }

    var overlayRect = stl_cont.getBoundingClientRect();
    var x = event.pageX - overlayRect.left;
    var y = event.pageY - overlayRect.top;
    direction = new THREE.Vector3(
      (x / overlayRect.width) * 2 - 1,
      -(y / overlayRect.height) * 2 + 1,
      0.5
    );
    direction.unproject(viewer.camera);
    direction.sub(viewer.camera.position);
    direction.normalize();
  }

  return direction;
}

function updateRaycaster(event) {
  try {
    let direction = getMouse3dDirection(event);
    if (!direction || !viewer.camera.position) return;

    if (
      !raycaster ||
      !raycaster.ray ||
      !raycaster.ray.direction ||
      !raycaster.ray.origin
    ) {
      raycaster = new THREE.Raycaster(
        viewer.camera.position, // origin
        direction,
        0.1,
        100000,
      );
    } else {
      raycaster.set(viewer.camera.position, direction);
    }
  } catch (error) {
    stlLogMessage(error);
  }
}

function intersectTooth(selectedId) {
  let tooth = null;
  try {
    let visibleTeeth = vueApp.allTeeth.filter((t) => t.isVisible);
    let visibleTeethMeshes = visibleTeeth
      .map((t) => viewer.get_model_mesh(t.id))
      .filter((mesh) => mesh && mesh.visible);
    let intersects = raycaster.intersectObjects(visibleTeethMeshes);
    if (intersects.length > 0) {
      //let intersectPoint = null;
      intersects.find((intersect) => {
        //intersectPoint = intersect.point;
        let objectUuid = intersect.object.uuid;
        tooth = vueApp.getToothByUuid(objectUuid);
        let retval = tooth != null && (!selectedId || tooth.id == selectedId);
        return retval;
      });

      if (tooth) {
        if (!tooth.isVisible && !vueApp.isHideMode) {
          tooth = null;
        }
        //event.intersectPoint = intersectPoint;
        //drawPoint(intersectPoint);
      }
    }
  } catch (error) {
    stlLogMessage(error);
  }

  return tooth;
}

function setHighlightedToothColor(hTooth) {
  if (hTooth && !hTooth.isHidden && !hTooth.extracted) {
    // console.log("setHighlightedToothColor", hTooth.name);
    let color = vueApp.getActualColor(hTooth);
    if (color.toLowerCase() == "#ffffff") {
      viewer.set_color(hTooth.id, greyTeethColor);
    } else {
      let mesh = viewer.get_model_mesh(hTooth.id);
      if (mesh && mesh.material && mesh.material.color) {
        let rgb = mesh.material.color;
        let r = Math.min(1.0, rgb.r + 0.2);
        let g = Math.min(1.0, rgb.g + 0.2);
        let b = Math.min(1.0, rgb.b + 0.2);
        mesh.material.color.setRGB(r, g, b);
      }
    }
  }
}

export { updateRaycaster, intersectTooth, setHighlightedToothColor, getMouse3dDirection };
